import { FieldMap, fnameField, lnameField } from '@hb/shared'

export const additionalPatientField: FieldMap = {
  name: 'Additional Patient',
  children: {
    fname: fnameField,
    lname: lnameField,
  },
}
